import React, { useEffect } from "react";
import DataTable from "datatables.net-react";
import DT from "datatables.net-bs5";

import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import "datatables.net-buttons-bs5/css/buttons.bootstrap5.min.css";
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // Responsive CSS

import "datatables.net-bs5";
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5"; // Responsive JS
import "datatables.net-buttons/js/buttons.html5.min.js";
import "datatables.net-buttons/js/buttons.print.min.js";
import "datatables.net-buttons/js/buttons.colVis.min.js";
import "jszip";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";
import "../Vendor/VendorLeads/VendorLeadDataTableCSS.css";
import { useNavigate } from "react-router-dom";
import $ from "jquery";

DataTable.use(DT);

export default function AllTotalLeadDatatable({ AllDataLeads }) {
  const navigate = useNavigate();
  const columns = [
    {
      title: "Lead Number",
      data: "id", // Data is not directly tied to this column
      render: (data, type, row) => {
        // return ` <a href="javascript:;" data-lead-id="${row.id}">${data} </a>`;
        return ` <a href="/task-details/${row.id}" class="lead-link" >${data} </a>`;
      },
    },
    {
      title: "Applicant Name",
      data: "name",
    },
    {
      title: "Lead Status",
      data: "status",
      render: (data, type, row) => {
        return `<span class="badge" style="color:${row.statuscolor};background-color:${row.statusbg};">${data}</span>`;
      },
    },
    { title: "Service", data: "service" },
    { title: "Start Date", data: "date" },
  ];

  useEffect(() => {
    $(document).on("click", ".lead-link", function (event) {
      event.preventDefault();
      const leadId = $(this).attr("href").split("/").pop();
      navigate(`/task-details/${leadId}`);
    });
  }, [navigate]);

  return (
    <>
      <div className="widget-content py-4 table-responsive">
        {AllDataLeads.length > 0 ? (
          <DataTable
            data={AllDataLeads || []}
            className="table table-striped table-bordered vendordatatable"
            columns={columns}
            responsive={true}
            noHeader={true}
            style={{ tableLayout: "auto", width: "100%" }}
            processing={true}
            options={{
              responsive: true,
              ordering: false,
              dom: "Bfrtip", // Adds the buttons at the top

              buttons: [
                {
                  extend: "copy",
                  text: `<i class="fa fa-clone"></i>`,
                  className: "btn btn-sm",
                  titleAttr: "Copy to clipboard",
                  exportOptions: {
                    columns: ":visible",
                  },
                },
                {
                  extend: "excelHtml5",
                  text: `<i class="fa fa-file-excel-o"></i>`,
                  className: "btn btn-sm",
                  titleAttr: "Export to Excel",
                  exportOptions: {
                    columns: ":visible",
                  },
                },
                {
                  extend: "pdfHtml5",
                  text: `<i class="fa fa-file-pdf-o"></i>`,
                  className: "btn btn-sm",
                  titleAttr: "Export to PDF",
                  exportOptions: {
                    columns: ":visible",
                  },
                },
                {
                  extend: "print",
                  text: '<i class="fa fa-print"></i>',
                  className: "btn btn-sm",
                  titleAttr: "Print table",
                  exportOptions: {
                    columns: ":visible",
                    modifier: {
                      page: "all",
                    },
                  },
                },
                {
                  extend: "colvis",
                  text: "Column Visibility", // Boxicon for Column Visibility
                  className: "btn btn-sm",
                  titleAttr: "Toggle column visibility",
                },
                {
                  extend: "pageLength",
                  text: "Show Rows",
                  className: "btn btn-sm",
                  titleAttr: "Change Number of Rows Displayed",
                },
              ],
              lengthMenu: [
                [10, 50, 100, 150, 200, -1],
                [10, 50, 100, 150, 200, "All"],
              ],

              colVis: {
                restore: true,
              },
            }}
          />
        ) : (
          <div className="noCommnetLead text-center">No Leads!</div>
        )}
      </div>
    </>
  );
}
